import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Perfil',
  lead: 'Tu nombre, idioma y ajustes de privacidad.',
  pendingBadge: '{{count}} solicitud de consentimiento pendiente',
  nav: {
    label: 'Menú del perfil',
    profile: 'Perfil',
    consents: 'Consentimientos',
    preferences: 'Preferencias',
    subscription: 'Suscripción',
  },
  preferredLanguage: 'Idioma preferido',
  preferredLanguageOptional: 'Idioma preferido (opcional)',
  preferredLanguageUnset: 'No definido',
  timezoneUnset: 'Valor predeterminado del entorno',
  saved: 'Guardado.',
  save: 'Guardar',
  privateFieldsHint:
    'Estos cuatro campos son privados — solo tú puedes verlos o cambiarlos, sea quien sea quien pueda ver el resto de tu registro.',
  details: {
    title: 'Datos',
    rolesTitle: 'Roles',
  },
  regionAndTimezone: {
    title: 'Región y zona horaria',
  },
  fields: {
    name: 'Nombre',
    email: 'Correo electrónico',
    nickname: 'Apodo',
    region: 'Región',
    regionUnset: 'No definido',
    regionHint: 'El país para el que se localizan tus estadísticas/informes.',
    timezone: 'Zona horaria para estadísticas',
    timezoneHint: 'El calendario con el que se cierran tus días de estadísticas.',
    gender: 'Género',
    birthdate: 'Fecha de nacimiento',
    height: 'Altura (cm)',
    weight: 'Peso (kg)',
  },
};
